import { regionColors, RegionKey, REGIONS_LABELS } from "@/types";
import {
  Box,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { Budge, Label, TextField } from "ui-components-library";

interface ChipSelectProps {
  regions: {
    label: string;
    value: number;
  }[];
  value?: number[];
  onChange?: (value: number[]) => void;
  error?: boolean;
  helperText?: string;
  loading?: boolean;
}

export const RegionChipSelect = ({
  regions,
  value = [],
  onChange,
  error,
  helperText,
  loading,
}: ChipSelectProps) => {
  const handleChangeRegion = (event: SelectChangeEvent<typeof value>) => {
    const {
      target: { value: newValue },
    } = event;

    const regionsIds =
      typeof newValue === "string"
        ? newValue.split(",").map(Number)
        : newValue.map(Number);

    if (onChange) {
      onChange(regionsIds);
    }
  };

  const getRegionColors = (region: string) => {
    return regionColors[region as RegionKey] || regionColors.OTHER;
  };

  return (
    <FormControl sx={{ width: "100%" }} error={error}>
      <Label label="Select Region*">
        <Select
          multiple
          value={value}
          onChange={handleChangeRegion}
          displayEmpty
          defaultValue={value}
          disabled={loading}
          sx={{ height: "40px" }}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return (
                <span style={{ fontSize: "20px", color: "#596668" }}>
                  Select From List
                </span>
              );
            }

            return (
              <>
                {loading ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CircularProgress size={15} />
                    <span style={{ fontSize: "20px", color: "#596668" }}>
                      Loading...
                    </span>
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", gap: "4px" }}>
                    {selected.map((regionId) => {
                      const region = regions.find((r) => r.value === regionId);
                      if (!region) return;

                      const { color, background } = getRegionColors(
                        region.label
                      );

                      return (
                        <Budge
                          key={region.value}
                          color={color}
                          background={background}
                        >
                          {region.label}
                        </Budge>
                      );
                    })}
                  </Box>
                )}
              </>
            );
          }}
        >
          {regions.map((region) => (
            <MenuItem key={region.value} value={region.value}>
              {region.label}
            </MenuItem>
          ))}
        </Select>
      </Label>
      {helperText && <TextField children={helperText} />}
    </FormControl>
  );
};
